import * as React from 'react';
import checkmark from '../../../../assets/images/static_pages/green_checkmark.svg';

interface DoubleCheckProps {
  feature: Record<string, any>;
  idx: number;
}
export const DoubleCheck = ({ feature, idx }: DoubleCheckProps) => {
  const [showHover, setShowHover] = React.useState(false);

  const color = idx % 2 === 0 ? 'rgba(224, 242, 227, 0.2)' : 'white';
  const hoverStateComponent = feature.hover_state ? (
    <>
      <span
        className="info-icon orange"
        onMouseEnter={() => setShowHover(true)}
        onMouseLeave={() => setShowHover(false)}
      >
        &nbsp;
        ⓘ
      </span>
      <span className={`hover-state ${showHover ? '' : 'hide'}`}>
        <p className="bold-800 mb-4">
          {feature.hover_state.title}
          :
        </p>
        <p>{feature.hover_state.content}</p>
      </span>
    </>
  ) : null;

  if (feature.numbers) {
    return (
      <tr style={{ background: color }}>
        <td className="title">
          { feature.title }
          { hoverStateComponent }
        </td>
        <td className="symbol middle-col center">
          {feature.numbers[0]}
        </td>
        <td className="symbol center">
          {feature.numbers[1]}
        </td>
        <td className="symbol center">
          {feature.numbers[2]}
        </td>
      </tr>
    );
  }

  const check = <img className="complete" src={checkmark} alt="checkmark" />;
  const firstTdContent = feature.check_count === 3 ? check : null;
  const secondTdContent = feature.check_count > 1 ? check : null;
  const thirdTdContent = feature.check_count > 1 ? check : null;

  return (
    <tr style={{ background: color }}>
      <td className="title">
        { feature.title }
        { feature.hover_state && hoverStateComponent }
      </td>
      <td className="symbol middle-col center">
        {firstTdContent}
      </td>
      <td className="symbol center">
        {feature.contact_us ? 'Contact Us' : secondTdContent}
      </td>
      <td className="symbol center">
        {thirdTdContent}
      </td>
    </tr>
  );
};
